module.exports = __webpack_public_path__ + "static/img/permit.971d13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/permit.png
// module id = WEqX
// module chunks = 1